import { render, staticRenderFns } from "./DashboardFamily.vue?vue&type=template&id=11d0b12a&"
import script from "./DashboardFamily.vue?vue&type=script&lang=js&"
export * from "./DashboardFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports